import { useEffect, useState } from 'react';
import axios from 'axios';

// Frontend build version — bump this on every meaningful UI/code change.
// Mismatch between FRONTEND_VERSION and backend version means redeploy is stale.
export const FRONTEND_VERSION = 'v1.28-multi-user';

const API = process.env.REACT_APP_BACKEND_URL;

export default function VersionBadge() {
  const [backendVersion, setBackendVersion] = useState('?');
  const [proxyCount, setProxyCount] = useState(null);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API}/api/version`)
      .then((r) => {
        if (!mounted) return;
        setBackendVersion(r.data.version || '?');
        if (typeof r.data.proxies === 'number') setProxyCount(r.data.proxies);
      })
      .catch(() => mounted && setBackendVersion('offline'));
    return () => {
      mounted = false;
    };
  }, []);

  const isMatch = backendVersion === FRONTEND_VERSION;
  const color = isMatch ? 'bg-emerald-500' : 'bg-amber-500';
  const title = isMatch
    ? `Backend and frontend versions match` +
      (proxyCount !== null ? `\nProxy rotation: ${proxyCount > 0 ? proxyCount + ' proxies' : 'DISABLED (direct connection)'}` : '')
    : `Backend: ${backendVersion} / Frontend: ${FRONTEND_VERSION} — redeploy may be in progress`;

  return (
    <div
      data-testid="version-badge"
      title={title}
      className="fixed bottom-3 right-3 z-50 flex items-center gap-2 rounded-full bg-zinc-900/90 px-3 py-1.5 text-[11px] font-mono text-white shadow-lg backdrop-blur-sm select-none"
    >
      <span className={`inline-block h-2 w-2 rounded-full ${color}`} />
      <span data-testid="version-backend">be: {backendVersion}</span>
      <span className="text-zinc-500">|</span>
      <span data-testid="version-frontend">fe: {FRONTEND_VERSION}</span>
      {proxyCount !== null && (
        <>
          <span className="text-zinc-500">|</span>
          <span
            data-testid="version-proxies"
            className={proxyCount > 0 ? 'text-emerald-400' : 'text-zinc-500'}
          >
            proxies: {proxyCount}
          </span>
        </>
      )}
    </div>
  );
}
